const NotReadyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" id="gear">
    <path
      d="M20 6.25V10M29.7227 10.2773L27.0711 12.9289M33.75 20H30M12.9289 27.0711L10.2773 29.7227M10 20H6.25M12.9289 12.9289L10.2773 10.2773M20.0002 33.75V30M27.0712 27.0711L29.7229 29.7227"
      stroke="white"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.0703 27.0703L29.722 29.722"
      stroke="#D9CED6"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M33.75 20H30" stroke="#B1A6AE" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M29.722 10.2734L27.0703 12.9251"
      stroke="#7F747C"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default NotReadyIcon
